var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import moment from "moment";
import { Table } from "@atlassiansox/microscopekit";
import styled from "styled-components";
var DateTimeSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
var ServiceNameB = styled.b(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
var ReleaseGroupsTableView = /** @class */ (function (_super) {
    __extends(ReleaseGroupsTableView, _super);
    function ReleaseGroupsTableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isDateTime: false,
        };
        _this.redirect = function (url) {
            window.location.replace(url);
        };
        return _this;
    }
    ReleaseGroupsTableView.prototype.render = function () {
        var _this = this;
        var data = this.props.releaseGroups
            .map(function (service) { return [
            React.createElement(ServiceNameB, { onClick: function () { return _this.redirect("/services/" + service.service); } }, service.service),
            React.createElement(DateTimeSpan, { onClick: function () { return _this.setState({ isDateTime: !_this.state.isDateTime }); } }, _this.state.isDateTime ? moment(service.timestamp).format("YYYY-MM-DD HH:mm:ss") : moment(service.timestamp).fromNow()),
            React.createElement("span", null, service.environment),
            React.createElement("span", null, service.release.description)
        ]; });
        return (React.createElement(Table, { className: "release-table", head: ["Service", "Deployed", "Environment", "DeploymentId"], emptyMessage: "No other services associated with this artifact in this environment", cells: data }));
    };
    return ReleaseGroupsTableView;
}(React.Component));
export { ReleaseGroupsTableView };
var templateObject_1, templateObject_2;
